import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "btp-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.css"]
})
export class ButtonComponent implements OnInit {
  @Input() text: string;
  @Input() size: "medium" | "large" = "large";
  @Input() color: "dark-green" | "orange" | "red" = "dark-green";
  @Input() disabled: boolean = false;

  disable: string;

  constructor() {}

  ngOnInit() {
    this.disable = this.disabled ? "disabled" : "";
  }
  
  ngOnChanges() {
    this.disable = this.disabled ? "disabled" : "";
  }
}
